/* eslint-disable */
import { useQuery } from 'vue-query';
import apiAxios from '../../apiAdminAxios';

const fetchTickets = async ({ page, per_page, search, search_status }) => {
  let URL = `?page=${page || 1}`;

  if (per_page) {
    URL += `&per_page=${per_page}`;
  }
  if (search) {
    URL += `&search=${search}`;
  }
  if (search_status) {
    URL += `&search_status=${search_status}`;
  }

  const { data } = await apiAxios.get(`/admin/tickets${URL}`);
  return data;
};

const changeTicketStatus = async ({ id, status }) => {
  let URL = `?status=${status}`;


  const { data } = await apiAxios.post(`/admin/tickets/${id}/update-status${URL}`);

  return data;
};

// queries
const useTicketsQuery = ({ page, per_page, search, search_status }) =>
  useQuery(
    ['admin/tickets', page, per_page, search, search_status],
    () => fetchTickets({ page, per_page, search, search_status }),
    { refetchOnMount: false },
  );

export default {
  // queries
  useTicketsQuery,
  changeTicketStatus
};
